import { render, staticRenderFns } from "./EventoList.vue?vue&type=template&id=1955238c&scoped=true"
import script from "./EventoList.vue?vue&type=script&lang=js"
export * from "./EventoList.vue?vue&type=script&lang=js"
import style0 from "./EventoList.vue?vue&type=style&index=0&id=1955238c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1955238c",
  null
  
)

export default component.exports